import type { Dispatch, SetStateAction } from "react";

import FeedbackTool from "@/features/request/feedback-tool/feedbackTool";
import { FeedbackToolProvider } from "@/features/request/feedback-tool/feedbackTool/components/FeedbackToolProvider.tsx";

type Attachment = {
  id: number;
  name: string;
  path: string;
  url: string;
};

type FeedbackToolComponentProps = {
  attachment: Attachment;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

export default function FeedbackToolComponent({
  attachment,
  open,
  setOpen,
}: FeedbackToolComponentProps) {
  return (
    <FeedbackToolProvider>
      {attachment ? (
        <FeedbackTool
          attachment={{
            id: attachment.id,
            name: attachment.name,
            path: attachment.path,
            url: attachment.url,
          }}
          key={attachment.id}
          open={open}
          setOpen={setOpen}
        />
      ) : null}
    </FeedbackToolProvider>
  );
}
